import React from 'react'
import PropTypes from 'prop-types'

/**
 * Loading - Displays a loading spinner with optional text
 * 
 * @component
 * @param {Object} props
 * @param {string} [props.text] - Loading text to display
 * @param {string} [props.size='md'] - Size of the spinner (sm, md, lg)
 * @param {string} [props.className] - Additional CSS classes
 * 
 * @example
 * <Loading text="Loading products..." size="lg" />
 */
const Loading = ({ text = 'Loading...', size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  }

  return (
    <div className={`flex flex-col items-center justify-center p-8 ${className}`}>
      <div className={`${sizeClasses[size]} animate-spin rounded-full border-4 border-primary-200 border-t-primary-500`} />
      {text && (
        <p className="mt-4 text-gray-600 text-center font-medium">{text}</p>
      )}
    </div>
  )
}

Loading.propTypes = {
  text: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
}

export default Loading
